import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installGlobalErrorHandlers } from "@/lib/errorLogger";

// Registrar handlers globales antes del primer render para no perder crashes
// tempranos (import fallidos, chunks 404 tras deploy, event handlers).
installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
